module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.14421/js/img/white_sprocket.svg"